/* eslint-disable no-undef */
import loadScript from '../../utils/load_script';
import AdException from '../errors/ad.exception';
import AdUnit from './adUnit';

export default class JsTagVideo {
  constructor(config) {
    this.URL_JSTAG_LIBRARY = process.env.URL_JSTAG_LIBRARY;
    this.config = config;
    this.adunit = null;
  }

  async loadLibrary() {
    await loadScript(this.URL_JSTAG_LIBRARY);
  }

  init(position) {
    let div = document.getElementById(this.config.targetAdId).querySelector('#video-ext-container');

    if (!div) {
      div = document.createElement('div');
      const target = document.getElementById(this.config.targetAdId);
      div.id = 'video-ext-container';
      target.appendChild(div);
    }

    this.adunit = new AdUnit(this.config)
      .setDivId(div.id)
      .setSizes(this.config.sizes, 'video')
      .setVideoParams(this.config, position)
      .buildVideo();

    if ((!this.adunit.tappxKey.mweb && !this.adunit.tappxKey.desktop) || !this.adunit.endpoint) {
      throw new AdException('AdUnit Params are empty', '201');
    }
  }

  async call() {
    if (typeof tappxTag === 'undefined') {
      this.loadLibrary();
    }

    if (document.getElementById(this.adunit.divId)) {
      document.getElementById(this.adunit.divId).innerHTML = '';
    }

    return new Promise((resolve, reject) => {
      window.tappxTag = window.tappxTag || {};
      window.tappxTag.cmd = window.tappxTag.cmd || [];

      window.tappxTag.cmd.push(() => {
        window.tappxTag.requestVideoBid(this.adunit, (result, data) => {
          if (result === 'OK') {
            resolve(data);
          } else if (result === 'error') {
            const dataResult = {};
            dataResult.typeAdServer = 'JSTAG';
            dataResult.message = `JsTag none ads returned`;
            dataResult.error = data;
            reject(dataResult);
          }
        });
      });
    });
  }
}
